
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: t('faq.q1'),
      answer: t('faq.a1')
    },
    {
      question: t('faq.q2'),
      answer: t('faq.a2')
    },
    {
      question: t('faq.q3'),
      answer: t('faq.a3')
    },
    {
      question: t('faq.q4'),
      answer: t('faq.a4')
    },
    {
      question: t('faq.q5'),
      answer: t('faq.a5')
    },
    {
      question: t('faq.q6'),
      answer: t('faq.a6')
    },
    {
      question: t('faq.q7'),
      answer: t('faq.a7')
    },
    {
      question: t('faq.q8'),
      answer: t('faq.a8')
    }
  ];

  return (
    <section className="w-full bg-white py-16 md:py-24" id="faq">
      <div className="container mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-blue-900 mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-[#f8f8f0] rounded-xl border border-gray-200 overflow-hidden transition-all duration-200 hover:shadow-md"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-6 text-left flex items-center justify-between focus:outline-none cursor-pointer"
                >
                  <span className="text-lg font-medium text-blue-900 pr-4">
                    {faq.question}
                  </span>
                  <div className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i 
                      className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl text-orange-500 transition-transform duration-200`}
                    />
                  </div>
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-6">
                    <div className="text-gray-700 leading-relaxed">
                      <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            {t('faq.stillHaveQuestions')}
          </p>
          <a 
            href="mailto:team.realrises@gmail.com"
            className="inline-flex items-center gap-2 text-orange-500 hover:text-orange-600 font-medium cursor-pointer"
          >
            <i className="ri-mail-line"></i>
            team.realrises@gmail.com
          </a>
        </div>
      </div>
    </section>
  );
}
